import {HttpClient, HttpParams} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Component} from '@angular/core';
import * as moment from 'moment-timezone';
import {ParksFetcher} from '@app/app/shared/helpers/parks.fetcher';
import {WebHttpUrlEncodingCodec} from '@app/app/shared/helpers/web.http.url.encoding.codec';

@Component({
  selector: 'app-reports',
  styleUrls: ['../reports.css'],
  templateUrl: './reports.alarms.component.html'
})
export class ReportsAlarmsComponent {

  public alarmTypes = [
    {id: 'chemical_alarm', label: 'Chemical alarm'},
    {id: 'UV-alarm', label: 'UV alarm'},
  ];

  public attributes = [
    {id: 'water_temp', label: 'Water temperature'},
    {id: 'air_temp', label: 'Air temperature'},
    {id: 'usage_rate', label: 'Usage rate'},
    {id: 'sand', label: 'Sand filter state'},
    {id: 'filter2', label: 'Y filter state'},
    {id: 'ph', label: 'pH'},
    {id: 'orp', label: 'ORP'},
  ];

  public parks = [];

  public selectedParks = [];
  public selectedType = null;
  public selectedFromDate = null;
  public selectedToDate = null;
  public isLoadingResults = false;

  public stats;

  public chartOptions = [];

  constructor(private http: HttpClient, private auth: AuthenticationService,
              private parksFetcher: ParksFetcher) {
    this.selectedFromDate = moment().startOf('year').toDate();
    this.selectedToDate = moment().endOf('day').toDate();
    this.selectedType = 'chemical_alarm';

    try {
      const parks = JSON.parse(sessionStorage.getItem('parks'));

      if (Array.isArray(parks) && parks.length > 0 && parks.length < 3) {
        this.selectedParks = parks;
      }
    } catch (e) {
      console.log(e);
    }

    this.isLoadingResults = true;

    this.parksFetcher.retrieveParks().subscribe((res) => {
      this.parks = res;

      if (Array.isArray(this.parks) && this.parks.length > 0) {
        if (this.selectedParks.length < 1) {
          this.selectedParks.push(this.parks[0].id);
        }

        this.reloadData();
      }
    }, (err) => {
      this.isLoadingResults = false;
    });
  }

  setStartDate(event) {
    this.selectedFromDate = moment(event.value).startOf('day').toDate();
    this.reloadData();
  }

  setEndDate(event) {
    this.selectedToDate = moment(event.value).endOf('day').toDate();
    this.reloadData();
  }

  setParks(value) {
    this.selectedParks = value;

    sessionStorage.setItem('parks', JSON.stringify(this.selectedParks));

    this.reloadData();
  }

  setType(value) {
    this.selectedType = value;
    this.reloadData();
  }

  private prepareDate(date) {
    const formattedDate = moment(date).format('YYYY-MM-DD HH:mm:ss.SSS');
    const inUtc = moment.tz(formattedDate, 'YYYY-MM-DD HH:mm:ss.SSS', 'UTC');

    return inUtc.valueOf();
  }

  private prepareParams() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('timestamps[from]', this.prepareDate(this.selectedFromDate))
      .set('timestamps[to]', this.prepareDate(this.selectedToDate))
      .set('type', 'alarm')
      .set('source', this.selectedType);

    this.selectedParks.forEach((selectedPark) => {
      params = params.append('parks[]', selectedPark);
    });

    return params;
  }

  private prepareStatsParams() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', 'alarm')
      .set('source', this.selectedType)
      .set('timestamps[from]', moment(this.selectedFromDate).valueOf())
      .set('timestamps[to]', moment(this.selectedToDate).valueOf());

    this.selectedParks.forEach(selectedPark => {
      params = params.append('parks[]', selectedPark);
    });

    return params;
  }

  private prepareParkName(parkId) {
    const parks = this.parks.filter(park => {
      return park.id === parkId;
    });

    if (parks.length === 1) {
      return parks[0].attributes.name;
    }

    return '';
  }

  private processResult(result: any, c) {
    const dataLabels = result.labels;
    const legends = [];
    const series = [];

    Object.keys(result.values).forEach((id: any) => {
      const cap = this.prepareParkName(id);

      legends.push(cap);

      series.push({
        name: cap,
        type: 'bar',
        label: cap,
        data: result.values[id]
      });
    });

    this.chartOptions[c] = {
      color: ['#4fc3f7', '#f74f8a'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        top: 20,
        data: legends,
      },
      grid: {
        top: 60,
        left: 80,
        right: 20,
        bottom: (c === 0 || c === 1 || c === 2) ? 80 : 63,
        containLabel: false
      },
      xAxis: [
        {
          type: 'category',
          data: dataLabels,
          axisLabel: {
            rotate: (c === 0 || c === 1) ? 90 : 0,
          },
          name: this.attributes[c].label,
          nameLocation: 'middle',
          nameGap: (c === 0 || c === 1 || c === 2) ? 55 : 38,
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Alarm occurrence',
          nameLocation: 'middle',
          nameGap: 55,
        }
      ],
      series: series,
    };
  }

  private reloadData() {
    if (this.selectedParks.length < 1) {
      return;
    }

    this.http.get<any>('/reports/alarms/statistics', {params: this.prepareStatsParams()}).subscribe(
      (res) => {
        this.stats = res;
      },
      (err) => {
        //
      },
      () => {
        //
      }
    );

    if (!this.selectedType) {
      return;
    }

    this.isLoadingResults = true;


    this.http.get<any>('/reports/alarms', {params: this.prepareParams()}).subscribe((result: any) => {
      this.isLoadingResults = false;

      this.attributes.forEach((attribute, index) => {
        this.processResult({labels: result.labels[attribute.id], values: result.values[attribute.id]}, index);
      });
    }, (err) => {
      this.isLoadingResults = false;
    }, () => {
      this.isLoadingResults = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/alarms/reports.alarms.component.ts